"use client"
import { createContext, useContext } from "react"
import { useQuery } from "urql"
import { getUserInfo } from "@tc/ui-dfe/query"

interface UserInfoContextProps {
  registrationArray: string[]
  loading: boolean
  error?: Error
}

interface UserInfoProviderProps {
  children: React.ReactNode
}

const UserInfoContext = createContext<UserInfoContextProps>({
  registrationArray: [],
  loading: true,
  error: undefined,
})

export const UserInfoProvider = ({ children }: UserInfoProviderProps) => {
  const [{ data, fetching, error }] = useQuery({
    query: getUserInfo.toString(),
  })

  return (
    <UserInfoContext.Provider
      value={{
        registrationArray: data?.getUserInfo?.registrations ?? [],
        loading: fetching,
        error,
      }}
    >
      {children}
    </UserInfoContext.Provider>
  )
}

export const useUserInfo = () => {
  return useContext(UserInfoContext)
}
